const mutations = {
    deviceUidMutation(state, value) {
        state.deviceUid = value;
    },
    openStatusMutation(state, value) {
        state.openStatus = value;
    },
};

export default mutations;